import {
  ReactElement,
  SyntheticEvent,
  useState,
  useCallback,
  // useMemo,
} from 'react';
import { AppBar } from '@mui/material';
import { TabContext, TabList } from '@mui/lab';

import { Menu } from '~components/index';

import { AddOrdersToRouteMenuProps } from './types';
import {
  AddOrdersToRouteMenuContainer,
  AddOrdersToRouteMenuTab,
  AddOrdersToRouteMenuTabPanel,
} from './styles';
import {
  AddOrdersToRouteMenuPending,
  AddOrdersToRouteMenuInProgress,
} from './Tabs';

const TABS_LIST = [
  {
    id: 'pending',
    label: 'En agenda',
  },
  {
    id: 'in-progress',
    label: 'En tránsito',
  },
];

const TABS_LIST_PANELS = [
  {
    id: TABS_LIST[0].id,
    panel: AddOrdersToRouteMenuPending,
  },
  {
    id: TABS_LIST[1].id,
    panel: AddOrdersToRouteMenuInProgress,
  },
];

const AddOrdersToRouteMenu = ({
  onClose,
  onClickCard,
  ...restProps
}: AddOrdersToRouteMenuProps): ReactElement => {
  const [activeTab, setActiveTab] = useState(TABS_LIST[0].id);

  const handleChangeActiveTab = useCallback(
    (_e: SyntheticEvent, newValue: string) => {
      setActiveTab(newValue);
    },
    [],
  );

  return (
    <Menu onClose={onClose} {...restProps}>
      <AddOrdersToRouteMenuContainer>
        <TabContext value={activeTab}>
          <AppBar position="static" color="tertiary" elevation={0}>
            <TabList
              onChange={handleChangeActiveTab}
              indicatorColor="primary"
              textColor="primary"
            >
              {TABS_LIST.map(({ label, id }) => (
                <AddOrdersToRouteMenuTab
                  key={`add-orders-menu-tab-${id}`}
                  label={label}
                  value={id}
                />
              ))}
            </TabList>
          </AppBar>

          {TABS_LIST_PANELS.map(({ id, panel: Panel }) => (
            <AddOrdersToRouteMenuTabPanel
              key={`add-orders-menu-tab-panel-${id}`}
              value={id}
            >
              <Panel onClickCard={onClickCard} />
            </AddOrdersToRouteMenuTabPanel>
          ))}
        </TabContext>
      </AddOrdersToRouteMenuContainer>
    </Menu>
  );
};

export default AddOrdersToRouteMenu;
